import usdtAbi from "../abi/erc20.json"
import checkInAbi from "../abi/checkIn.json"
import mintAbi from "../abi/mint.json"
import agentMintAbi from "../abi/mint.agent.json"
const usdtContractAddress = "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd"
const CheckInContractAddress = "0x225b47b2631ac36d50428b84e327c0a757cb5c5c"
const mintAddress = "0x655728739b92eE3b12bab860D4A6537341758240"
const agentMintAddress = "0x8410080c05F5A45fcB4b452C8ed6CbaFde25F9a1"


import usdtAbiMain from "../abi/erc20.mainnet.json"
import checkInAbiMain from "../abi/checkIn.mainnet.json"
import mintAbiMain from "../abi/mint.mainnet.json"
import agentMintAbiMain from "../abi/mint.agent.json"
const usdtContractAddressMain = "0x55d398326f99059fF775485246999027B3197955"
const CheckInContractAddressMain = "0x078b911F04554D514128F91AD89B31c24068cAEF"
const mintAddressMain = "0x7a1Be56dBA9E2E09d0E86b4dD2f4BFA3049a2268"
const agentMintAddressMain = "0x30192E742C33101e7dc9f27676bac592F80688a4"

console.log(import.meta.env.VITE_BSC_CHAIN_ID)


export const usdtContract = {
    abi: import.meta.env.VITE_BSC_CHAIN_ID == 97 ? usdtAbi : usdtAbiMain,
    address: import.meta.env.VITE_BSC_CHAIN_ID == 97 ? usdtContractAddress : usdtContractAddressMain,

}

export const mintContract = {
    abi: import.meta.env.VITE_BSC_CHAIN_ID == 97 ? mintAbi : mintAbiMain,
    address: import.meta.env.VITE_BSC_CHAIN_ID == 97 ? mintAddress : mintAddressMain,
}

export const checkInContract = {
    abi: import.meta.env.VITE_BSC_CHAIN_ID == 97 ? checkInAbi : checkInAbiMain,
    address: import.meta.env.VITE_BSC_CHAIN_ID == 97 ? CheckInContractAddress : CheckInContractAddressMain,
}

export const agentMintContract = {
    abi: import.meta.env.VITE_BSC_CHAIN_ID == 97 ? agentMintAbi : agentMintAbiMain,
    address: import.meta.env.VITE_BSC_CHAIN_ID == 97 ? agentMintAddress : agentMintAddressMain,
}